import { FuelButton } from '@frete.com/fuel-react'
import * as Styled from './styled'
import { Text } from '~constants/text'
import { useTranslator } from '~hooks'
import { Props } from './interfaces'

function FeedbackScreen({ image, title, description, width, height }: Props) {
  const { translate } = useTranslator()
  return (
    <Styled.ContainerEditEmail>
      {image}
      <Styled.TitleEditEmail>{title}</Styled.TitleEditEmail>
      <div>
        <Styled.DescriptionEditEmail $width={width} $height={height}>
          {description}
        </Styled.DescriptionEditEmail>
      </div>
      <FuelButton href="https://www.fretebras.com.br/tipo-de-cadastro?q=entrar">
        {translate(Text.LOGIN_ACCOUNT)}
      </FuelButton>
    </Styled.ContainerEditEmail>
  )
}

export default FeedbackScreen
